import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Avatar,
  Stack,
  Chip,
  Button,
} from "@mui/material";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import { useAuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AdminTopbar({ title, subtitle, onMenuClick, showMenu }) {
  const { adminLogout } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    adminLogout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(14px)",
        borderBottom: "1px solid rgba(11,18,32,0.08)",
        color: "text.primary",
      }}
    >
      <Toolbar sx={{ minHeight: 72, gap: 1.5, px: { xs: 1.5, md: 3 } }}>
        {showMenu && (
          <IconButton
            onClick={onMenuClick}
            sx={{ border: "1px solid rgba(11,18,32,0.10)", borderRadius: 1 }}
          >
            <MenuRoundedIcon />
          </IconButton>
        )}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.1 }}>
            <Typography
              sx={{
                fontWeight: 1000,
                fontSize: 18,
                letterSpacing: -0.4,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </Typography>
            <Chip
              label="Admin"
              size="small"
              sx={{
                borderRadius: 1,
                bgcolor: "rgba(37,99,235,0.08)",
                color: "primary.main",
                fontWeight: 900,
              }}
            />
          </Stack>
          {subtitle && (
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: 12,
                mt: 0.1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1,
              bgcolor: "rgba(37,99,235,0.12)",
              color: "primary.main",
              border: "1px solid rgba(37,99,235,0.22)",
              fontWeight: 900,
              fontSize: 14,
            }}
          >
            A
          </Avatar>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Typography sx={{ fontWeight: 900, fontSize: 13, lineHeight: 1.1 }}>
              Admin
            </Typography>
            <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
              Time ONURB
            </Typography>
          </Box>
        </Stack>

        <Button
          onClick={handleLogout}
          startIcon={<LogoutRoundedIcon />}
          size="small"
          sx={{
            borderRadius: 1,
            border: "1px solid rgba(11,18,32,0.12)",
            color: "text.secondary",
            fontWeight: 700,
            fontSize: 12,
            "&:hover": { color: "error.main", borderColor: "error.light" },
          }}
        >
          Sair
        </Button>
      </Toolbar>
    </AppBar>
  );
}
